<app-moveable-panel>
  @let canViewAlertSopLink = Permission.ViewAlertSopLink | hasPermission;

  <div class="flex flex-col">
    <app-movable-panel-title>
      <div class="grow flex items-center justify-between">
        <span>{{ 'multi-site-dashboard.site-alerts.title' | translate }}</span>
        <ng-content></ng-content>
      </div>
    </app-movable-panel-title>
    @if (vm(); as viewModel) {
      <div class="px-2">
        <app-alerting-card-table
          [vm]="viewModel"
          [sopColumnIsHidden]="!canViewAlertSopLink"
          [createdAtRightAligned]="true"
          [emptyText]="'alerting.no-site-alerts' | translate"
          (sortChange)="sortChange.emit($event)"
        />
      </div>
    }
    <div class="flex items-center justify-end p-4">
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites]">
        <app-panel-link [label]="'multi-site-dashboard.view-sites' | translate"></app-panel-link>
      </a>
    </div>
  </div>
</app-moveable-panel>
